export default "__VITE_ASSET__BMOQ2qpv__"